<script setup>
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const emits = defineEmits(['closeModal', 'showToast']);
  const { t } = useI18n();
  const i18nScope = ref('components.users_management');

  const props = defineProps({
    userData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    computedPrivileges: {
      type: Object,
      required: true
    },
  });

  const camelToSnakeCase = (str) => {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  };
</script>

<template>
  <h4>{{ t(`${i18nScope}.user_details.summary`) }}</h4>
  <table class="table table-bordered table-striped">
    <tbody>
      <tr v-if="userData.role && userData.role.name">
        <th scope="row">{{ t(`${i18nScope}.user_details.role`) }}</th>
        <td>{{ userData.role.name }}</td>
      </tr>
      <tr v-if="userData.network && userData.network.name">
        <th scope="row">{{ t(`${i18nScope}.user_details.network`) }}</th>
        <td>{{ userData.network.name }}</td>
      </tr>
      <tr v-if="userData.library && userData.library.name">
        <th scope="row">{{ t(`${i18nScope}.user_details.library`) }}</th>
        <td>{{ userData.library.name }}</td>
      </tr>
      <tr v-if="userData.firstName">
        <th scope="row">{{ t(`${i18nScope}.user_details.first_name`) }}</th>
        <td>{{ userData.firstName }}</td>
      </tr>
      <tr v-if="userData.lastName">
        <th scope="row">{{ t(`${i18nScope}.user_details.last_name`) }}</th>
        <td>{{ userData.lastName }}</td>
      </tr>
      <tr v-if="userData.mail">
        <th scope="row">{{ t(`${i18nScope}.user_details.email`) }}</th>
        <td>{{ userData.mail }}</td>
      </tr>

      <template v-for="(value, privilege) in computedPrivileges">
        <tr v-if="value">
            <th scope="row">{{ t(`${i18nScope}.columns.${camelToSnakeCase(privilege)}`) }}</th>
          <td>
            <i :class="userData[privilege] ? 'bi bi-check-circle-fill icon_green' : 'bi bi-x-circle-fill icon_red'"></i>
          </td>
        </tr>
      </template>
        
      
    </tbody>
  </table>
</template>

